import * as React from 'react';
import Inquery from './inquery'
import Goods from './goods';
import { useAppSelector } from '../../redux/hooks';

import './index.scss';

export default function Index ( props:any ) {
    const { productIsMarketGoods, inventory, sampleInventory, visitCountry} = props;


    if (!productIsMarketGoods) {
      return <Inquery {...props} type="inquery" country={visitCountry} dispatchId={sampleInventory?.samplePreferedDispatchId} />
    }

    // 切仓需要更新
    const skuInfo = useAppSelector( state =>  state.sku.goods);
    return <Goods {...props} type="goods" country={visitCountry} dispatchId={skuInfo.dispatchId || inventory.preferedDispatchId} />
}
